
import Vue, { PropType } from 'vue';
import FeatureTourMedia from './FeatureTourMedia.vue';
import { FeatureTourMediaType } from '../types/featureTour';

export default Vue.extend({
	name: 'FeatureTourCard',
	components: { FeatureTourMedia },
	props: {
		stepId: { type: String, required: true },
		stepIndex: { type: Number, required: true },
		totalSteps: { type: Number, required: true },
		title: { type: String, required: true },
		description: { type: String, required: true },
		mediaUrl: { type: String, default: null },
		mediaType: { type: String as PropType<FeatureTourMediaType>, default: 'video' },
		mediaPlaceholderLabel: { type: String, default: '' },
		posterUrl: { type: String, default: null },
		icon: { type: String, default: '' },
		widthVariant: { type: String, default: 'standard' },
		allowBack: { type: Boolean, default: true },
		primaryLabel: { type: String, default: null },
		eyebrowLabel: { type: String, default: '' },
	},
});
